import Nullstack from 'nullstack';
export default function IconComet({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-comet",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M15.5 18.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5z"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "4",
    x2: "11",
    y2: "11"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "4",
    x2: "12.5",
    y2: "7.5"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "9",
    x2: "7.5",
    y2: "12.5"
  }), " ");
}